import {ICalEvent} from "../domain/dtos/i-cal-event.dto";
import {Entity} from "../domain/entities/entity";
import {TransformerInterface} from "./transformerInterface";
import {ConfluenceUser} from "../domain/dtos/confluence-user.dto";
import {Employee} from "../domain/entities/employee.entity";
import {container} from "tsyringe";
import {EmployeeRepository} from "../domain/repositories/employee.repository";
import {ArrayHelper} from "../helpers/array.helper";

export abstract class AbstractIcalToEntityTransformer<T extends Entity|null, S = ICalEvent> implements TransformerInterface<T, S> {

    private _employeeRepository: EmployeeRepository;

    protected constructor() {
        this._employeeRepository = container.resolve(EmployeeRepository);
    }

    protected async _getEmployees(confluenceUsers: ConfluenceUser | ConfluenceUser[]): Promise<Employee[]> {
        if (!Array.isArray(confluenceUsers)) {
            confluenceUsers = [confluenceUsers].filter(a => !!a);
        }

        const employees = [];
        for(const confluenceUser of confluenceUsers) {
            let nameString = confluenceUser.params?.CN || null;
            if (!nameString) {
                continue;
            }

            if (nameString?.startsWith('"') && nameString?.endsWith('"')) {
                try {
                    nameString = JSON.parse(nameString) as string;
                } catch (e) {
                    continue;
                }
            }

            const [lastName, firstName] = nameString.split(/[,.]/).map(t => t.trim());
            const employee = await this._employeeRepository.findOneByFullName(lastName, firstName);

            if(!employee) {
                continue;
            }
            employees.push(employee);
        }

        return employees;
    }

    protected async _getCreator(organizer: ConfluenceUser | ConfluenceUser[]): Promise<Employee|null> {
        return ArrayHelper.first(await this._getEmployees(organizer));
    }

    public abstract transform(inputObject: S, payload?: any): Promise<T>;

}